import { getGridTemplateColumns, getGridTemplateRows } from "../utils/gridUtils";
import { GridLayoutOptions } from "../types";
import { useMediaQuery, useTheme } from "@mui/material";

export const useGridLayout = (options: GridLayoutOptions) => {
    const { columns = 1, rows = 1, spacing = 0, rowGap, columnGap, grow = false, columnWidth = "equal" } = options;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const colIndices = (() => Array.from({ length: columns }).map((_, i) => i))();
    const rowIndices = (() => Array.from({ length: rows }).map((_, i) => i))();

    const resolvedRowGap = rowGap ?? spacing;
    const resolvedColumnGap = columnGap ?? spacing;
    const rowGapSize = (() => parseInt(theme.spacing(resolvedRowGap)))();
    const columnGapSize = (() => parseInt(theme.spacing(resolvedColumnGap)))();

    const responsiveColumns = isMobile && columns > 1 ? 1 : columns;

    const gridTemplateColumns = (() => getGridTemplateColumns(responsiveColumns, columnWidth))();

    const gridTemplateRows = (() => getGridTemplateRows(rows, grow))();

    const gridStyle = (() => ({
        display: "grid",
        gridTemplateColumns,
        gridTemplateRows,
        rowGap: `${rowGapSize}px`,
        columnGap: `${columnGapSize}px`,
        width: "100%",
        minHeight: grow ? "250px" : "auto",
    }))();

    return {
        colIndices,
        rowIndices,
        gridStyle,
    };
};
